<template>
  <Modal :is-open="isOpen" @update:is-open="handleIsOpenUpdate" :onClose="onClose" modal-width="400px" max-height="337px">
    <template #body>
      <div class="d-flex column gap-16 items-center justify-center text-center success-modal-body leaning-24">
        <div class="success-modal-icon">
          <Icons name="rating" />
        </div>
        <div class="d-flex column gap-16 items-center justify-center text-center">
          <span class="text-b18 color-black text-bold">گزارش شما با موفقیت ثبت شد</span>
          <span class="text-b14 color-on-cont-dim text-medium text-center description">
            از اینکه ما را در ارائه خدمات بهتر همراهی می‌کنید سپاس‌گزاریم. پس از بررسی گزارش شما توسط کارشناسان، اقدامات لازم انجام خواهد گرفت.
          </span>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="button-container">
        <BaseButton type="outlined" @click="onClose"> متوجه شدم </BaseButton>
      </div>
    </template>
  </Modal>
</template>
<script setup lang="ts">
import Modal from '@/components/base/modal/index.vue';
import Icons from '@/components/base/icon/index.vue';
import BaseButton from '@/components/base/button/index.vue';
defineProps<{
  isOpen: boolean;
  onClose: () => void;
}>();
const emit = defineEmits(['update:isOpen']);
const handleIsOpenUpdate = (value: boolean) => {
  emit('update:isOpen', value);
};
</script>
<style scoped lang="scss">
@import url('./success-modal.scss');
</style>
